import { Download } from '@mui/icons-material';
import { Box, Button, Divider, Typography } from '@mui/material';
import { get } from 'lodash';
import React, { FC } from 'react';
import CreateForm from 'src/components/ui-component/form-component/create-form/CreateForm';
import MarkdownRenderer from 'src/components/ui-component/markdown-renderer/MarkdownRenderer';
import { useApplication } from 'src/context/ApplicationContext';
import { ANTRAG_TYP, ANTRAGS_FORMULAREN, ART_DES_ANTRAGS } from 'src/lib/constants/constant';
import { FormStrucItem } from 'src/lib/types/types';
import ApplicationHeading from 'src/pages/private/online-antrag/application-heading/ApplicationHeading';
import { DownloadAntragPDF } from 'src/pages/private/online-antrag/DownloadAntragPDF';

// import schemas
import Schema from 'src/lib/paths/antrag_FULL_Paths.json';
const P = Schema.attributes;

/**
 * TODO: Refactor duplicated code with FoerderAntragRightSidebar.tsx
 * Es gibt noch die gleiche Logik für ImagesPaths in FoerderAntragRightSidebar.tsx
 * Das muss noch zusammengeführt werden.
 */
const ImagesPathsEmobFundE = [
	P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0009162530_FE_Ausgangssituation_Bilder.path,
	P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0178136770_reibung_Des_Vorhabens_Bilder.path,
	P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0139433634_sblick_Und_Verwertung_Bilder.path,
];
const ImagesPathsEmobInvest = [
	P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0095548994_est_Ausgangssituation_Bilder.path,
	P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0112109858_ionen_Elektrofahrzeug_Bilder.path,
	P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0193290210_nen_Ladeinfrastruktur_Bilder.path,
	P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0103379282_toff_Betankungsanlage_Bilder.path,
	P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0220424306_chreibung_Und_Vergabe_Bilder.path,
	P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0109936114_onstige_Informationen_Bilder.path,
];
const ImagesPathsLoewe = [
	// Ausgangssituation
	P.Projektbeschreibung_Loewe.schema.attributes.Ausgangssituation_Bilder.path,
	P.Projektbeschreibung_Loewe.schema.attributes.Gegenwaertiger_Stand_Technik_Bilder.path,
	P.Projektbeschreibung_Loewe.schema.attributes.Notwendigkeit_Einer_Neuartigen_Loesung_Bilder.path,
	P.Projektbeschreibung_Loewe.schema.attributes.Zielstellung_Und_Anforderungsprofil_Bilder.path,
	P.Projektbeschreibung_Loewe.schema.attributes.Innovationsgrad_Und_Alleinstellungsmerkmale_Bilder.path,
	P.Projektbeschreibung_Loewe.schema.attributes.Kernkompetenzen_Der_Verbundpartner_Bilder.path,
	// Beschreibung des Vorhabens
	P.Projektbeschreibung_Loewe.schema.attributes.Gegenwaertiger_Entwicklungsstand_Patentrecherche_Bilder.path,
	P.Projektbeschreibung_Loewe.schema.attributes.Technologische_Realisierung_Und_Entwicklungsschritte_Bilder.path,
	P.Projektbeschreibung_Loewe.schema.attributes.Massnahmen_Einer_Kommerzialisierung_Bilder.path,
	P.Projektbeschreibung_Loewe.schema.attributes.Begruendung_Einer_Staatlichen_Foerderung_Bilder.path,
	// Markt analyse
	P.Projektbeschreibung_Loewe.schema.attributes.Marktanalyse_Wettbewerbstechnologien_Bilder.path,
	P.Projektbeschreibung_Loewe.schema.attributes.Anwendungsgebiete_Und_Kundennutzen_Bilder.path,
	P.Projektbeschreibung_Loewe.schema.attributes.Markteintrittsstrategie_Markteinfuehrungserfolge_Bilder.path,
	P.Projektbeschreibung_Loewe.schema.attributes.Moegliche_Markteintrittsbarrieren_Bilder.path,
	P.Projektbeschreibung_Loewe.schema.attributes.Schutzrechte_Lizenzen_Zwischen_Verbundpartnern_Bilder.path,
	P.Projektbeschreibung_Loewe.schema.attributes.Unternehmensentwicklung_Erwartete_Arbeitsplatzeffekte_Bilder.path,
	// Wissenschaftliche Effekte
	P.Projektbeschreibung_Loewe.schema.attributes.Wissenschaftliche_Effekte_Bilder.path,
	// Organisation
	P.Projektbeschreibung_Loewe.schema.attributes.Meilensteinplanung_Bilder.path,
	// Standort Effekte
	P.Projektbeschreibung_Loewe.schema.attributes.Aussendarstellung_Bilder.path,
	// Skizze
	P.Projektbeschreibung_Loewe.schema.attributes.Entwicklungsvorhaben_Bilder.path,
	P.Projektbeschreibung_Loewe.schema.attributes.Alleinstellungsmerkmale_Bilder.path,
	P.Projektbeschreibung_Loewe.schema.attributes.Marktanalyse_Bilder.path,
];

const AbschlussAntragHerunterladen: FC<{ untertitel: string; inhalt: string }> = ({ untertitel, inhalt }) => {
	const { application, readOnly, setApplicationProperty, saveApplication } = useApplication();

	const antragsFormular = get(application, P.Allgemein_Antragsformular.path);
	let ImagesPaths: any[] = [];
	if (antragsFormular === ANTRAGS_FORMULAREN.EmobFundE) {
		ImagesPaths = ImagesPathsEmobFundE;
	} else if (antragsFormular === ANTRAGS_FORMULAREN.EmobInvest) {
		ImagesPaths = ImagesPathsEmobInvest;
	} else if (antragsFormular === ANTRAGS_FORMULAREN.Loewe) {
		ImagesPaths = ImagesPathsLoewe;
	}

	const antragsTyp = get(application, P.Allgemein_Typ.path, '');
	const artDesAntrags = get(application, P.Allgemein_Art_Des_Antrags.path, '');
	const isFormantrag = artDesAntrags === ART_DES_ANTRAGS.Formantrag;
	const handleDownloadAntrag = () => {
		DownloadAntragPDF(application, readOnly, saveApplication, ImagesPaths);
	};

	return (
		<>
			<ApplicationHeading title={untertitel} />
			<MarkdownRenderer markdown={inhalt} />

			<Button variant='outlined' startIcon={<Download />} onClick={() => handleDownloadAntrag()}>
				{antragsTyp === ANTRAG_TYP.Skizze ?
					'Skizze herunterladen'
				: isFormantrag ?
					'Formantrag herunterladen'
				:	'Antrag herunterladen'}
			</Button>

			<Divider sx={{ mt: '2rem' }} />
			<ApplicationHeading title={'Feedback gewünscht?'} />

			{(
				get(application, P.Allgemein_Antragsformular.path) === ANTRAGS_FORMULAREN.EmobLis ||
				get(application, P.Allgemein_Antragsformular.path) === ANTRAGS_FORMULAREN.Kreativwirtschaft ||
				get(application, P.Allgemein_Antragsformular.path) === ANTRAGS_FORMULAREN.Entwicklungszusammenarbeit ||
				get(application, P.Allgemein_Antragsformular.path) === ANTRAGS_FORMULAREN.Loewe ||
				get(application, P.Allgemein_Antragsformular.path) === ANTRAGS_FORMULAREN.StartUpProjekte ||
				get(application, P.Allgemein_Antragsformular.path) === ANTRAGS_FORMULAREN.StartUpStipendium
			) ?
				<>
					<Typography>
						Sie hatten noch keinen Kontakt zu unseren Förderexperten oder möchten an dieser Stelle gerne eine Einschätzung zu Ihrem
						Antragsentwurf haben? <strong>Dann melden Sie sich gerne direkt bei uns!</strong>
					</Typography>
				</>
			:	<>
					<Typography>
						Sie hatten noch keinen Kontakt zu unseren Förderexperten oder möchten an dieser Stelle gerne eine Einschätzung zu Ihrem
						Antragsentwurf haben? Dann laden Sie hier das aktuelle Dokument hoch und schreiben Sie uns über das Textfeld unten eine kurze
						Nachricht:
					</Typography>
					<Box sx={{ mt: '1rem' }}>
						<CreateForm
							formStruc={formStrucFeedbakUpload()}
							formValues={application}
							updateFormValuesFunc={setApplicationProperty}
							readOnly={readOnly}
							size='small'
						/>
						<CreateForm
							formStruc={formStrucHinweis()}
							formValues={application}
							updateFormValuesFunc={setApplicationProperty}
							readOnly={readOnly}
						/>
					</Box>
				</>
			}
		</>
	);
};

export default AbschlussAntragHerunterladen;

const formStrucFeedbakUpload = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [{ ...P.Allgemein_Feedback, maxFileSize: 10000000, hideLabel: true }],
			userProps: { columnToDivide: 2 },
		},
	];
	return struc;
};

const formStrucHinweis = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [P.Allgemein_Feedback_An_Die_HA],
			userProps: { columnToDivide: 1 },
		},
	];
	return struc;
};
